import { SearchResultsInterface } from 'common/types/entities/search-results-interface'

export const getSearchResultsFontProperties = (
  entity: SearchResultsInterface,
) => {
  const fontProperties = []
  if (entity.title.fontFamily) {
    fontProperties.push({
      fontFamily: entity.title.fontFamily,
      fontStyle: entity.title.fontStyle,
      fontWeight: entity.title.fontWeight,
    })
  }

  if (entity.title.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.title.mobileFontFamily,
      fontStyle: entity.title.mobileFontStyle,
      fontWeight: entity.title.mobileFontWeight,
    })
  }

  if (entity.text.fontFamily) {
    fontProperties.push({
      fontFamily: entity.text.fontFamily,
      fontStyle: entity.text.fontStyle,
      fontWeight: entity.text.fontWeight,
    })
  }

  if (entity.text.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.text.mobileFontFamily,
      fontStyle: entity.text.mobileFontStyle,
      fontWeight: entity.text.mobileFontWeight,
    })
  }

  if (entity.date.fontFamily) {
    fontProperties.push({
      fontFamily: entity.date.fontFamily,
      fontStyle: entity.date.fontStyle,
      fontWeight: entity.date.fontWeight,
    })
  }

  if (entity.date.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.date.mobileFontFamily,
      fontStyle: entity.date.mobileFontStyle,
      fontWeight: entity.date.mobileFontWeight,
    })
  }

  if (entity.total.fontFamily) {
    fontProperties.push({
      fontFamily: entity.total.fontFamily,
      fontStyle: entity.total.fontStyle,
      fontWeight: entity.total.fontWeight,
    })
  }

  if (entity.total.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.total.mobileFontFamily,
      fontStyle: entity.total.mobileFontStyle,
      fontWeight: entity.total.mobileFontWeight,
    })
  }
  return fontProperties
}

export const getSearchResultsCustomFontProperties = (
  entity: SearchResultsInterface,
) => {
  const fontProperties = []

  if (entity.title.fontFamily && entity.title.fontFileId) {
    fontProperties.push({
      fontFamily: entity.title.fontFamily,
      fontFileId: entity.title.fontFileId,
    })
  }
  if (entity.title.mobileFontFamily && entity.title.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.title.mobileFontFamily,
      fontFileId: entity.title.mobileFontFileId,
    })
  }

  if (entity.text.fontFamily && entity.text.fontFileId) {
    fontProperties.push({
      fontFamily: entity.text.fontFamily,
      fontFileId: entity.text.fontFileId,
    })
  }
  if (entity.text.mobileFontFamily && entity.text.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.text.mobileFontFamily,
      fontFileId: entity.text.mobileFontFileId,
    })
  }

  if (entity.date.fontFamily && entity.date.fontFileId) {
    fontProperties.push({
      fontFamily: entity.date.fontFamily,
      fontFileId: entity.date.fontFileId,
    })
  }
  if (entity.date.mobileFontFamily && entity.date.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.date.mobileFontFamily,
      fontFileId: entity.date.mobileFontFileId,
    })
  }

  if (entity.total.fontFamily && entity.total.fontFileId) {
    fontProperties.push({
      fontFamily: entity.total.fontFamily,
      fontFileId: entity.total.fontFileId,
    })
  }
  if (entity.total.mobileFontFamily && entity.total.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.total.mobileFontFamily,
      fontFileId: entity.total.mobileFontFileId,
    })
  }

  return fontProperties
}
